import React from 'react';
import { FormControl, Select, MenuItem } from '@mui/material';
import translations from '../../shared/en.json';
import { reportStyles } from '../../shared/globalSX';

const DataLimitSelector = ({ value, onChange }) => (
  <FormControl size="small" sx={{ minWidth: 100 }}>
    <Select
      value={value}
      onChange={onChange}
      sx={{ 
        height: 32, 
        fontSize: '13px',
        ...reportStyles.reportSelect
      }}
    >
      <MenuItem value="5">{translations.dataLimit.top5}</MenuItem>
      <MenuItem value="10">{translations.dataLimit.top10}</MenuItem>
      <MenuItem value="15">{translations.dataLimit.top15}</MenuItem>
      <MenuItem value="all">{translations.dataLimit.all}</MenuItem>
    </Select>
  </FormControl>
);

export default DataLimitSelector;
